import { fromCondition } from "@otto-ec/assets-core-utils/nano-effect";
import { toggle } from "@gr-exports/async/toggle";
import { getPagecluster } from "@gr-exports/async/misc";
import { random } from "@gr-common/async/tools";
import type { AgentConfigOptions } from "@elastic/apm-rum";
import { noops } from "./utils";

export interface SamplingConfig {
  /**
 *
 *
 *
 */
  active: number;
  /**
 *
 *
 */
  pageLoad: number;
  /**
 *
 *
 */
  other: number;
}

/**
 *
 */
export interface SamplingEnvConfig {
  /**
 *
 *
 */
  [pagecluster: string]: Partial<SamplingConfig>;
  /**
 *
 *
 */
  default: SamplingConfig;
}

/**
 *
 *
 */
export type InitConfig = [config: AgentConfigOptions, labels: Labels, isActive: boolean];

/**
 *
 */
export const sampligRates: Record<"live" | "develop", SamplingEnvConfig> = {
  live: {
    Artikeldetailseite: { active: 0.5, pageLoad: 0.08 },
    Suchergebnisseite: { active: 0.6 },
    Storefront: { active: 0.7 },
    default: { active: 1, pageLoad: 0.1, other: 0.001 },
  },
  develop: {
    default: { active: 1, pageLoad: 1, other: 0.5 },
  },
};

/**
 *
 */
export const withApmInitializationConfiguration = fromCondition(
  location.hostname.endsWith("otto.de") && toggle.get("gr_enable_apm_agent", true),
  (rate = random(), pc = getPagecluster()): InitConfig => {
    /*                                                                                  */
    const envRates =
      sampligRates[import.meta.env.VITE_OTTO_INSTALLATION_ENV] ?? sampligRates.develop;

    /*                                         */
    const pagecluster = pc ?? "unknown";
    const rates = { ...envRates.default, ...envRates[pagecluster] };

    const rateLabels = Object.fromEntries(
      Object.entries(rates).map(([k, v]) => [`sample_rate_${k}`, v] as const),
    );

    /*                                                                 */
    const { labels: serverLabels = {}, ...serverConfig } = { ...window.__APM__ };
    const labels = { ...rateLabels, pagecluster, ...serverLabels };

    return [
      {
        serviceName: import.meta.env.VITE_OTTO_INSTALLATION_NAME,
        serverUrl: import.meta.env.VITE_ELASTIC_APM_SERVER_URL,
        environment: import.meta.env.VITE_OTTO_INSTALLATION_ENV,
        pageLoadSampled: rate <= rates.pageLoad,
        pageLoadTransactionName: pc ?? undefined,
        transactionSampleRate: rates.other,
        ...serverConfig,
      },
      labels,
      rate <= rates.active,
    ];
  },
  () => noops,
);
